import { render, staticRenderFns } from "./IntroLong.vue?vue&type=template&id=578eb73f&scoped=true&"
import script from "./IntroLong.vue?vue&type=script&lang=ts&"
export * from "./IntroLong.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578eb73f",
  null
  
)

export default component.exports